import { createAction, createAsyncAction } from 'typesafe-actions';

import { MarketCalendar, PublicHoliday } from '../types';

export const getCalendars = createAsyncAction(
  'publicHolidayCalendar/getCalendars/request',
  'publicHolidayCalendar/getCalendars/success',
  'publicHolidayCalendar/getCalendars/failure',
)<undefined, { calendars: MarketCalendar[] }, string>();

export const getHolidays = createAsyncAction(
  'publicHolidayCalendar/getHolidays/request',
  'publicHolidayCalendar/getHolidays/success',
  'publicHolidayCalendar/getHolidays/failure',
)<undefined, { holidays: PublicHoliday[]; year: number }, string>();

export const setSelectedYear = createAction(
  'publicHolidayCalendar/setSelectedYear',
)<number>();

export const setSelectedCalendars = createAction(
  'publicHolidayCalendar/setSelectedCalendars',
)<number[]>();
